import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // #region Quick CabinetPOST
    GetQuickBusinessStatusList({ rootGetters }, request) {
      return axios
        .post('closethighway/GetQuickBusinessStatusList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取久大經銷商數據信息
    GetQuickDealersList({ rootGetters }, request) {
      return axios
        .post('closethighway/GetQuickDealersList', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //設置久大經銷商詳細信息
    SetQuickDealersInfo({ rootGetters }, request) {
      return axios
        .post('closethighway/SetQuickDealersInfo', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取久大經銷商訂單費用
    GetQuickDealersOrderList({ rootGetters }, request) {
      return axios
        .post('closethighway/GetQuickDealersOrderList', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取久大經銷商訂單費用詳細信息
    GetQuickDealersOrderInfo({ rootGetters }, request) {
      return axios
        .post('closethighway/GetQuickDealersOrderInfo', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //設置久大經銷商收款確認
    SetQuickDealersOrderExpense({ rootGetters }, request) {
      return axios
        .post('closethighway/SetQuickDealersOrderExpense', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //導出經銷商報價單
    ExportDealersPriceExcel({ rootGetters }, request) {
      return axios
        .post(
          'closethighway/ExportDealersPriceExcel',
          {
            ...request
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          if (response.data.Values && response.data.Values.ReqInt === -1) {
            return Promise.reject('發生錯誤')
          } else {
            return Promise.resolve(response.data)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickCabinetStyleList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickCabinetStyleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddQuickCabinetStyleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddQuickCabinetStyleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetQuickCabinetStyleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/SetQuickCabinetStyleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleQuickCabinetStyleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/DeleQuickCabinetStyleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetTypeAdd({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetTypeAdd', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -2) {
            return Promise.reject('已有相同名稱的櫃型')
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetTypeRead({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetTypeRead', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetTypeModify({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetTypeModify', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -2) {
            return Promise.reject('已有相同名稱的櫃型')
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetTypeDelete({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetTypeDelete', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickCabinetCategoryList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickCabinetCategoryList', {
          ...request
        })
        .then((response) => {
          if (!response.data.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddQuickCabinetCategoryInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddQuickCabinetCategoryInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetQuickCabinetCategoryInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/SetQuickCabinetCategoryInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleQuickCabinetCategoryInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/DeleQuickCabinetCategoryInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetTypeList({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetTypeList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetAdd({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetAdd', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -2) {
            return Promise.reject('櫃體重複')
          } else if (response.data.Values.ReqInt === -3) {
            return Promise.reject('櫃體類型不存在')
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetRead({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetRead', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetModify({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetModify', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetDelete({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetDelete', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetList({ rootGetters }, request) {
      return axios
        .post('closetHighway/CabinetList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //快客訂單匯出Excel
    QuickOrderExcelExport({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickOrderExcelExport', { ...request }, { responseType: 'blob' })
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetExport({ rootGetters }, request) {
      return axios
        .post(
          'closetHighway/CabinetExport',
          {
            ...request
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CabinetImport({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('RawBoardExcelFile', request.RawBoardExcelFile)
      return axios
        .post('closetHighway/CabinetImport', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //删除附件
    DeleQuickProductOrderDemandFile({ rootGetters }, request) {
      return axios
        .post('DeleQuickProductOrderDemandFile', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //制造商 拆單附件上傳完成
    SetQuickProductOrderPrice({ rootGetters }, request) {
      let formData = new FormData()
      formData.append('OrderID', request.OrderID)
      request.DemandXmls.forEach((demand, index) => {
        formData.append(`DemandXmls[${index}].DemandID`, demand.DemandID)
        formData.append(`DemandXmls[${index}].ManufacturerProcessFile`, demand.ManufacturerProcessFile)
        formData.append(`DemandXmls[${index}].PackageRemark`, demand.PackageRemark)
        formData.append(`DemandXmls[${index}].IsFileExist`, demand.IsFileExist)
      })

      return axios
        .post('SetQuickProductOrderPrice', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else if (response.data.Values.ReqInt === -5) {
            return Promise.reject({
              message: '訂單內有排除的封邊類型',
              data: {
                edgeBandingExcludeBoards: response.data.Values.EdgeBandingExcludeBoards
              }
            })
          } else if (response.data.Values.ReqInt === -4) {
            return Promise.reject({
              message: '缺少的原料板',
              data: {
                lackRawBoards: response.data.Values.OrderPriceLackRawBoards
              }
            })
          } else if (response.data.Values.ReqInt === -3) {
            return Promise.reject({
              message: '缺少物料',
              data: {
                lackBoards: response.data.Values.LackBoards,
                lackMetals: response.data.Values.LackMetals
              }
            })
          } else if (response.data.Values.ReqInt === -2) {
            return Promise.reject('XML格式錯誤')
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //制造商获取商城生产订单明细
    ManufacturerOrderRead({ rootGetters }, request) {
      return axios
        .post('/ManufacturerOrderRead', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //将快客订单添加到生产订单
    AddQuickOrderInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddQuickOrderInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //管理员新增使用者
    MemberRegistration({ rootGetters }, request) {
      return axios
        .post('/MemberRegistration', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取公司部门接口
    GetCompaniesDeptList({ rootGetters }, request) {
      return axios
        .post(process.env.BASE_URL + 'api/Permissions/GetCompaniesDeptList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取后台人员订单
    GetQuickBusinessOrderList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickBusinessOrderList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取后台人员订单详情
    GetQuickBusinessOrderDetail({ rootGetters }, request) {
      return axios
        .get('closetHighway/GetQuickBusinessOrderDetail', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ReportDeliveryOrderExcel({ rootGetters }, request) {
      return axios
        .post('closethighway/ReportDeliveryOrderExcel', { ...request }, { responseType: 'blob' })
        .then((response) => {
          if (response.data.Values && response.data.Values.ReqInt === -1) {
            return Promise.reject('發生錯誤')
          } else {
            return Promise.resolve(response.data)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ModifyQuickBusinessOrder({ rootGetters }, request) {
      return axios
        .post('closetHighway/ModifyQuickBusinessOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateQuickBusinessOrder({ rootGetters }, request) {
      return axios
        .post('closetHighway/UpdateQuickBusinessOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取热销产品列表
    GetQuickHotCommodityList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickHotCommodityList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 添加热销产品柜
    AddQuickHotCommodityInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddQuickHotCommodityInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 编辑热销产品柜
    EditQuickHotCommodityInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/EditQuickHotCommodityInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //删除热销产品柜
    DeleQuickHotCommodityInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/DeleQuickHotCommodityInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取快客柜滚动条信息
    GetCabinetTitleInfoList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetCabinetTitleInfoList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 新增快客柜滚动条信息
    AddCabinetTitleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddCabinetTitleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 修改快客柜滚动条信息
    ModifyCabinetTitleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/ModifyCabinetTitleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 删除快客柜滚动条信息
    DeleCabinetTitleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/DeleCabinetTitleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 设置工班排班表
    SetScheduleList({ rootGetters }, request) {
      return axios
        .post('closetHighway/SetWorkingScheduleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取工班排班表
    GetScheduleList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetWorkingScheduleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取子柜体列表
    GetQuickSubTypeGroupInfoList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickSubTypeGroupInfoList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //查詢櫃子信息
    GetCabinetInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetCabinetInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddQuickSubTypeGroupInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddQuickSubTypeGroupInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetQuickSubTypeGroupInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/SetQuickSubTypeGroupInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleQuickSubTypeGroupInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/DeleQuickSubTypeGroupInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickOrderChangeStatus({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickOrderChangeStatus', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateThisMonthPref({ rootGetters }, request) {
      return axios
        .put('closetHighway/UpdateThisMonthPref', {
          ...request
        })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickSubTypeGroupInfoCabinet({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetQuickSubTypeGroupInfoCabinet', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    GetCabinetUpdateList({ rootGetters }, request) {
      return axios
        .post('closetHighway/GetCabinetUpdateList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddAotuQuickTitleInfo({ rootGetters }, request) {
      return axios
        .post('closetHighway/AddAotuQuickTitleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandList({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandDelete({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandDelete', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandRead({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandRead', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandAdd({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandAdd', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject('品牌名稱重複')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandModify({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandModify', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject('品牌名稱重複')
          } else if (response.data.Values.ReqInt === -2) {
            return Promise.reject('品牌不存在')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardBrandBoardModify({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardBrandBoardModify', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject('板材內容重複')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickBoardListByBrand({ rootGetters }, request) {
      return axios
        .post('closetHighway/QuickBoardListByBrand', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    GetStoreInfoList({ rootGetters }) {
      return axios
        .post('GetStoreInfoList')
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickCabinetStatusList({ rootGetters }, request) {
      return axios
        .post('closethighway/GetQuickCabinetStatusList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜介绍人List接口
    GetPetCabinetReferrerList({ rootGetters }, request) {
      return axios
        .post('PetCabinet/GetPetCabinetReferrerList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetPetCabinetReferrerByNumber({ rootGetters }, request) {
      return axios
        .get('PetCabinet/GetPetCabinetReferrerByNumber', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜购买人增加接口
    AddPetCabinetBuyer({ rootGetters }, request) {
      return axios
        .post('PetCabinet/AddPetCabinetBuyer', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜介绍人增加接口
    AddPetCabinetReferrer({ rootGetters }, request) {
      return axios
        .post('PetCabinet/AddPetCabinetReferrer', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜介绍人修改接口
    EditPetCabinetReferrer({ rootGetters }, request) {
      return axios
        .post('PetCabinet/EditPetCabinetReferrer', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜介绍人获取单一对象接口
    GetPetCabinetReferrerById({ rootGetters }, request) {
      return axios
        .get('PetCabinet/GetPetCabinetReferrerById', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //宠物柜介绍人删除接口
    DeletePetCabinetReferrerById({ rootGetters }, request) {
      return axios
        .get('PetCabinet/DeletePetCabinetReferrerById', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetPetCabinetBuyerList({ rootGetters }, request) {
      return axios
        .post('PetCabinet/GetPetCabinetBuyerList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickOrderByNameAndMobile({ rootGetters }, request) {
      return axios
        .post('PetCabinet/GetQuickOrderByNameAndMobile', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdatePetCabinetBuyerStatus({ rootGetters }, request) {
      return axios
        .post('PetCabinet/UpdatePetCabinetBuyerStatus', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdatePetCabinetBuyerCompareStatus({ rootGetters }, request) {
      return axios
        .post('PetCabinet/UpdatePetCabinetBuyerCompareStatus', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    PetCabinetExport({ rootGetters }, request) {
      return axios
        .post(
          'PetCabinet/PetCabinetDownloadExcel',
          {
            ...request
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
    // #endregionPOST
  }
}
